<template>
  <vue-navigation-bar :options="navbarOptions" ref="navbar">
    <template v-slot:custom-section v-if="isSmallDevice">
      <p>
        <a href="javascript:void(0)" @click="router('home')">
          <span class="logoTilt" style="font-size:24px;">{{ $t('COMMON_TITLE') }}</span>
        </a>
      </p>
      <Select v-model="locale" @on-change="changeLang" style="width: 100px; padding: 5px;">
        <Option value="zh-TW">繁體中文</Option>
        <Option value="en">English</Option>
        <Option value="zh-CN">简体中文</Option>
      </Select>
      <Select clearable filterable v-model="groupCode" @on-change="changeGroup($event)" style="width: 160px; padding: 5px;">
        <Option v-for="(item, index) in groupList" :value="item.code" :key="index">{{ item.code }}</Option>
      </Select>
      <template v-if="isLogin"  style="padding: 2px;">
        <Dropdown @on-click="auhtControl($event)" style="margin-left: 18px">
          <Button style="width: 280px; font-size:18px;" >
            {{ account }}
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="logout" style="font-size:24px;">{{ $t('COMMON_TEXT_LOGOUT') }}</DropdownItem>
            <DropdownItem v-if="isSystemAdmin" name="switchUser" style="font-size:24px;">{{ $t('COMMON_TEXT_SWITCH_USER') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
      <template v-if="!isLogin">
        <div class="logoTilt p-1">{{ $t('LOGIN') }} <i class="fa fa fa-sign-in" @click="login"></i></div>
      </template>

      <a class="cursor" @click="redirectOldEc" style="padding: 5px;">{{ $t('OLD_EC') }} <i class="fa fa-2x fa-share-square-o "></i></a>
    </template>
    <Modal :z-index="modalSize" :reset-drag-position="true" v-model="switchUserModal" sticky :draggable="true" :title="$t('COMMON_TEXT_SWITCH_USER')" @on-ok="confirmSwitchUser">
      <FormRow :fieldNameArr="[$t('LOGIN_ACCOUNT')]">
        <Input v-model="switchUserName" v-upper-case slot="a" />
      </FormRow>
    </Modal>
  </vue-navigation-bar>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import "vue-navigation-bar/dist/vue-navigation-bar.css"
import VueNavigationBar from "vue-navigation-bar"
import { delCookie, setCookie } from "@/util/cookie"
import { Translate } from "@/util/common"

export default {
  name: "NavigationBar",
  components: {
    VueNavigationBar,
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getLogin", "getSmallDevice", "getGroupCode", "getMenuOptionsLeft", "getModalSize"]),
    ...mapActions(["setLanguage", "setLogin", "setGroupCode", "toggleLoading", "setUserProfile", "setMenuOptionsLeft"]),
    router(path) {
      this.$router.push(`/${path}`, () => {})
    },
    auhtControl(action) {
      if (action == "logout") {
        delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
        this.setLogin(false)
        if (this.$router.history.current.fullPath != "/home") {
          this.$router.push("/home")
        }
      } else if (action == "switchUser") {
        this.switchUserModal = true
      }
    },
    changeLang() {
      this.setLanguage(this.locale)
      this.$buildMenuPage(this, this.menuPages)
      if (this.$router.history.current.fullPath.includes("/account/maintain")) {
        this.$router.push("/home", () => {})
      }
    },
    changeGroup(value) {
      if (value) {
        this.setGroupCode(this.groupList.filter((group) => group.code == value)[0])
        this.toggleLoading(true)
        this.$authHttp
          .get("current-user")
          .then((response) => {
            console.log(response.data)
            this.toggleLoading(false)
            response.data.ecGroups = response.data.ecGroups.sort(function(a, b) {
              return a.code.localeCompare(b.code, "en");
            })
            this.setUserProfile(response.data)
            if (this.$router.history.current.fullPath != "/home") {
              this.$router.push("/home")
            }
          })
          .catch((error) => {
            let text = this.$buildErrorMessage(error)
            this.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          })
      }
    },
    confirmSwitchUser() {
      this.toggleLoading(true)
      this.$authHttp.put("switch-user", JSON.stringify({
          username: this.switchUserName
        }))
        .then((response) => {
          this.toggleLoading(false)
          this.switchUserName = ""
          setCookie(process.env.VUE_APP_AUTH_TOKEN_NAME, response.data.access_token, 1000 * 60 * 60 * 5)
          this.setGroupCode(null)
          this.$readUserDetail(this)
        })
        .catch((error) => {
          let text = this.$buildErrorMessage(error)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            text,
          })
        })
    },
    redirectOldEc() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$authHttp
        .get("/old-ec/login")
        .then((response) => {
          vueInstance.toggleLoading(false)
          let lang = this.getLanguage() == "en" ? 'ENG' : 'CHT'
          window.location.href = `${process.env.VUE_APP_OLD_EC_URL}ezECWeb/LoginDispatch?uuPart=` + response.data.content + `&userLang=` + lang
        })
        .catch((error) => {
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
      })
    }
  },
  data() {
    return {
      locale: this.getLanguage(),
      switchUserModal: false,
      switchUserName: "",
      navbarOptions: {
        elementId: "main-navbar",
        isUsingVueRouter: true,
        collapseButtonOpenColor: "#00a0e9",
        collapseButtonCloseColor: "#00a0e9",
        tooltipAnimationType: "scale",
        menuOptionsLeft: [],
        mobileBreakpoint: 992,
      }
    }
  },
  watch: {
    menuPages(val, oldVal) {
      this.$buildMenuPage(this, val)
    },
    menuOptionsLeft(val, oldVal) {
      this.navbarOptions.menuOptionsLeft = val
    },
    deep: true,
  },
  computed: {
    menuPages() {
      return this.getUserProfile().menuPages
    },
    isLogin() {
      return this.getLogin()
    },
    account() {
      return this.getUserProfile().user.username
    },
    groupList() {
      return this.getUserProfile().ecGroups?.filter(g => g.isLock === false)
    },
    isSmallDevice() {
      return this.getSmallDevice()
    },
    isSystemAdmin() {
      return this.getUserProfile() && this.getUserProfile().systemRoles && this.getUserProfile().systemRoles.includes('SYSTEM_ADMIN')
    },
    groupCode: {
      get() {
        return this.getGroupCode() ? this.getGroupCode().code : ""
      },
      set(val){}
    },
    menuOptionsLeft() {
      return this.getMenuOptionsLeft()
    },
    modalSize() {
      return this.getModalSize()
    }
  },
}

</script>

<style>
.vnb__collapse-button {
  margin-right: 1.7rem;
}
.vnb__popup__bottom {
  height: 500px;
  overflow-y: auto;
}
.vnb__menu-options--left {
  padding-left: 6%;
}
.vnb__menu-options__option__link {
  font-size: 18px;
}

#main-navbar {
  box-shadow: 0 0px 2px rgb(0 0 0 / 40%);
}
</style>
